import { render } from "./MainLayout.vue?vue&type=template&id=16b3eef5&bindings={\"error\":\"setup\",\"setError\":\"setup\"}"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
script.render = render

export default script